import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiRequest } from "services/ServiceUtil";
import { RECOMMNDATION_SERVICE_METHOD } from "services/commonService";
import { setInitialWizardTaken } from "utils/SharedUtils";
import { OnboardingState } from "./Onboarding";

const SLICE = "OnboardingQueries";

const initialState: OnboardingState = {
  Onboarding: {},
  checkApiResponse: {},
  isOnboardingCompleted: true,
  showOnboardingWizard: true,
  showOnboardingWizardFromLibrary: false,
  showWizardLoader: false,
  initialWizard: false,
  isOnboardingCheckApiCompleted: false,
  retakeWizardRequired: false,
  isRetakeWizard: false,
  onboardingCompletionDatePresent: true
};

export const fetchOnboardingQueries = createAsyncThunk(`${SLICE}/fetchOnboardingQueries`, (data: any, thunkApi) => {
  return apiRequest(RECOMMNDATION_SERVICE_METHOD.getWizards, {}, thunkApi, [data.wizardType], data?.payload);
});

export const fetchOnboardingQueriesCheck = createAsyncThunk(
  `${SLICE}/fetchOnboardingQueriesCheck`,
  (data: any, thunkApi) => apiRequest(RECOMMNDATION_SERVICE_METHOD.getWizardsCheck, {}, thunkApi, [], data)
);

export const updateOnboardingQueries = createAsyncThunk(`${SLICE}/updateOnboardingQueries`, (data: any, thunkApi) => {
  return apiRequest(RECOMMNDATION_SERVICE_METHOD.putWizardsResponse, data.payload, thunkApi);
});

export const OnboardingSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: () => initialState,
    setShowOnboardingWizard: (state, action) => {
      state.showOnboardingWizard = action.payload;
    },
    setShowOnboardingWizardFromLibrary: (state, action) => {
      state.showOnboardingWizardFromLibrary = action.payload;
    },
    setInitialWizard: (state, action) => {
      state.initialWizard = action.payload;
    },
    resetOnBoardingDetails: (state, action) => {
      state.isOnboardingCompleted = true;
      state.onboardingCompletionDatePresent = true;
    },
    setIsRetakeWizard: (state, action) => {
      state.isRetakeWizard = action.payload;
    },
    setRetakeWizardRequired: (state, action) => {
      state.retakeWizardRequired = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOnboardingQueries.pending, (state) => {
        state.showWizardLoader = true;
      })
      .addCase(fetchOnboardingQueries.fulfilled, (state, action) => {
        state.showWizardLoader = false;
        const { status, ...payload } = action.payload;
        state.Onboarding = payload;
      })
      .addCase(fetchOnboardingQueries.rejected, (state) => {
        state.showWizardLoader = false;
      })
      .addCase(fetchOnboardingQueriesCheck.fulfilled, (state, action) => {
        state.checkApiResponse = action.payload;
        state.initialWizard = !!action.payload?.createdDate;
        if (!!action.payload?.createdDate) setInitialWizardTaken();

        if (action.payload?.errors) {
          state.isOnboardingCompleted = true;
          state.onboardingCompletionDatePresent = true;
        } else {
          state.isOnboardingCompleted = !!action.payload?.createdDate;
          state.onboardingCompletionDatePresent = !!action.payload?.createdDate;
        }

        if (action.payload.retakeWizardRequired) {
          state.isOnboardingCompleted = false;
          state.showOnboardingWizardFromLibrary = true;
          state.isRetakeWizard = true;
          state.retakeWizardRequired = true;
        }
        state.isOnboardingCheckApiCompleted = true;
      })
      .addCase(fetchOnboardingQueriesCheck.rejected, (state) => {
        state.isOnboardingCompleted = true;
        state.onboardingCompletionDatePresent = true;
        state.isOnboardingCheckApiCompleted = true;
      })
      .addCase(updateOnboardingQueries.fulfilled, (state, action) => {
        state.isOnboardingCompleted = !!action.payload.createdDate;
        state.onboardingCompletionDatePresent = !!action.payload.createdDate;
        state.retakeWizardRequired = false;
      });
  }
});

export const {
  reset,
  setShowOnboardingWizard,
  setShowOnboardingWizardFromLibrary,
  setInitialWizard,
  resetOnBoardingDetails,
  setIsRetakeWizard,
  setRetakeWizardRequired
} = OnboardingSlice.actions;

export default OnboardingSlice.reducer;
